import { BrowserRouter as Router } from 'react-router-dom';
import { useEffect, useRef } from 'react';

import TranslationsContext from 'services/context/translationsContext';
import { useLoadTranslations } from 'services';
import { IS_EFBET, siteFavicon } from 'services/constants';

import { AppRouter } from './';

const App = () => {
  const translations = useLoadTranslations();
  const loaded = useRef(null);

  useEffect(() => {
    if (loaded.current) return;

    const head = document.head;

    let link =
      document.querySelector("link[rel='icon']") ||
      document.querySelector("link[rel='shortcut icon']");

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      head.appendChild(link);
    }

    link.href = siteFavicon;

    if (siteFavicon.endsWith('.svg')) link.type = 'image/svg+xml';

    loaded.current = true;
  }, []);

  useEffect(() => {
    const mainColor = IS_EFBET ? '#ffdd00' : '#c03';
    document.documentElement.style.setProperty('--main-color', mainColor);
  }, []);

  return (
    <TranslationsContext.Provider value={{ translations }}>
      <Router>
        <AppRouter />
      </Router>
    </TranslationsContext.Provider>
  );
};

export default App;
